<template>
    <div class="form-group" :class="{'row':vertical}" ref="selectEl">
        <label v-if="label" :class="labelColClass" class=" input-search-padding">{{label}}</label>
        <div :class="formColClass">
            <select class="form-control select" ref="select2" v-model="usingValue" data-fouc>
                <option v-for="(option,index) in usingOptions" :key="index" :value="option.value">{{option.text}}</option>
            </select>
            <span class="form-text" :class="{'border-danger':validClass,'text-danger':validClass}" v-for="resultStr in validationResult" :key="resultStr">{{resultStr}}</span>
        </div>
    </div>
</template>

<script>
    import validation from "@/config/mixin/validation";

    export default {
        name: "select-2",
        mixins:[validation],
        props: {
            rule: {
                type:String
            },
            options: {
                type: Array,
                required: true
            },
            label: {
                type: String,
            },
            vertical: {
                type: Boolean
            },
            value: {
                default: ''
            },
            labelColSize: {
                type: Number,
                default: 3
            },
            defaultOptionText: {
                type: String,
            },
            defaultOption: {
                type: Boolean,
                default: true
            }
        },
        computed: {
            target: function() {
                return $(this.$refs.select2)
            },
            formColClass: function() {
                let formSize = 12 - this.labelColSize
                return this.vertical ? "col-"+formSize : ''
            },
            labelColClass: function() {
                let clazz = this.vertical ? "col-"+this.labelColSize + ' col-form-label': ''
                if(this.validationResult.length > 0) clazz = clazz + ' text-danger'
                return clazz
            },
            usingOptions: function() {
                return [...this.defaultOptions,...this.options]
            },
            validClass: function() {
                return this.validationResult.length > 0
            },
            defaultOptions: function() {
                let text = 'Choose...'
                if(this.defaultOptionText) text = this.defaultOptionText
                return this.defaultOption ? [{text: text, value: ''}] : []
            }
        },
        data() {
            return {
                usingValue:'',
            }
        },
        mounted() {
            if (!$().select2) {
                console.warn('Warning - select2.min.js is not loaded.');
                return;
            }

            $('.select').select2({
                minimumResultsForSearch: Infinity
            });

            let vue = this
            this.target.select2({
                minimumResultsForSearch: Infinity
            });
            this.usingValue = this.value
            this.target.on('select2:select', function (e) {
                vue.$emit('input',e.params.data.id)
            });
            this.target.val(this.usingValue).trigger('change')
        },
        methods: {
            validator: function() {
                this.validationResult = []
                this.validationResult = this.getValidationResult(this.rule,this.usingValue,'select')
                let elem = $(this.$refs.selectEl).find('.select2-selection')
                if(this.validationResult.length > 0) {
                    elem.attr('style','border: 1px solid #f44336 !important;')
                } else {
                    elem.attr('style','')
                }
                return this.validationResult
            },
        },
        watch: {
            'value':function(val) {
                this.usingValue = val
                this.validator()
            },
            'usingValue': function(val) {
                this.target.val(val).trigger('change')
                this.$emit('change',val)
            }
        }
    }
</script>

<style scoped>
    .select2-padding {
        padding-top: calc(.4375rem + 1px);
        padding-bottom: calc(.4375rem + 1px);
    }
</style>
